import { render, staticRenderFns } from "./SimilarJobs.vue?vue&type=template&id=92716234&scoped=true&"
import script from "./SimilarJobs.vue?vue&type=script&lang=ts&"
export * from "./SimilarJobs.vue?vue&type=script&lang=ts&"
import style0 from "./SimilarJobs.vue?vue&type=style&index=0&id=92716234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92716234",
  null
  
)

export default component.exports